import { SendSalesEmailFromLandingBodyDto } from 'app/API';
import { TForm } from '@pages/ContactSales/types/TForm';

export const buildSalesEmailRequestBody = (formState: TForm): SendSalesEmailFromLandingBodyDto => ({
  name: formState.details.name,
  surname: formState.details.surname,
  email: formState.details.email,
  phone: formState.details.phone,
  typeOfWork: formState.typeOfWork,
  companyName: formState.companyName,
  role: formState.role,
  tools: formState.tools,
  interested: formState.interested,
  autoScriptAccount: formState.autoScriptAccount,
  outsource: formState.outsource,
  outsourceTo: formState.outsourceTo,
  notes: formState.notes,
  notSureNotes: formState.notSureNotes,
});
